import { apiRequest } from "../util/apiUtils";

export const userCollectionList = async (params) => {
  try {
    const res = await apiRequest("get", `/collection/list`, {
      queries: params,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};
export const userCollectionDelete = async (payload) => {
  try {
    const res = await apiRequest("delete", `/collection/collection-delete`, {
      body: payload,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};
export const userCollectionPagesList = async (params) => {
  try {
    const res = await apiRequest("get", `/collection/pages`, {
      queries: params,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};
